import { HandleKeyDownProps } from "@/types/utils";

export const handleKeyDown = ({ event, isDisabled, handleSendMessage }: HandleKeyDownProps) => {
  if (event.key === "Enter" && !event.shiftKey && !isDisabled) {
    event.preventDefault();
    handleSendMessage();
  }
};
